(() => {
  const root = document.getElementById('bs-mini-cart');
  if (!root) return;

  const pill = document.getElementById('bs-mini-cart-pill');
  const panel = document.getElementById('bs-mini-cart-panel');
  const items = document.getElementById('bs-mini-cart-items');
  const count = document.getElementById('bs-mini-cart-count');
  const total = document.getElementById('bs-mini-cart-total');
  const discount = document.getElementById('bs-mini-cart-discount');
  const discountValue = document.getElementById('bs-mini-cart-discount-value');
  const more = document.getElementById('bs-mini-cart-more');
  const error = document.getElementById('bs-mini-cart-error');
  const status = document.getElementById('bs-mini-cart-status');
  const cartUrl = root.dataset.cartUrl || '/cart';
  let cart = null;
  let updating = false;
  let refreshRequest = 0;
  const cartChangeKey = 'bs-cart-changed';

  function announceCartChanged() {
    try {
      localStorage.setItem(cartChangeKey, `${Date.now()}-${Math.random()}`);
    } catch (reason) {
      // Cart updates in this tab still work when browser storage is unavailable.
    }
  }

  function positionPill() {
    root.style.bottom = '';
    root.style.removeProperty('--bs-mini-cart-panel-space');
    if (root.hidden || innerWidth < 750 || !document.querySelector('product-info[id^="MainProduct-"]')) return;
    const pillRect = pill.getBoundingClientRect();
    const controls = [
      document.querySelector('product-info[id^="MainProduct-"] .product-form__submit'),
      document.querySelector('product-info[id^="MainProduct-"] .shopify-payment-button'),
    ].map((node) => node?.getBoundingClientRect()).filter((rect) => rect && rect.bottom > 0 && rect.top < innerHeight);
    const overlaps = controls.some((rect) => pillRect.left < rect.right + 12 && pillRect.right > rect.left - 12 && pillRect.top < rect.bottom + 12 && pillRect.bottom > rect.top - 12);
    if (!overlaps) return;
    const top = Math.min(...controls.map((rect) => rect.top));
    root.style.bottom = `${Math.max(20, innerHeight - top + 12)}px`;
    root.style.setProperty('--bs-mini-cart-panel-space', `${Math.max(160, pill.getBoundingClientRect().top - 75)}px`);
  }

  function money(cents) {
    const currency = cart?.currency || 'JPY';
    return new Intl.NumberFormat('ja-JP', {
      style: 'currency', currency,
      maximumFractionDigits: currency === 'JPY' ? 0 : 2,
    }).format(cents / 100);
  }

  function close() {
    panel.hidden = true;
    pill.setAttribute('aria-expanded', 'false');
  }

  function open() {
    if (!cart?.item_count) return;
    panel.hidden = false;
    pill.setAttribute('aria-expanded', 'true');
    document.querySelector('cart-notification')?.dispatchCartViewEvent?.();
  }

  function syncHeaderCount() {
    if (!cart) return;
    const header = document.querySelector('#cart-icon-bubble');
    if (header) {
      let bubble = header.querySelector('.cart-count-bubble');
      if (!cart.item_count) bubble?.remove();
      else {
        if (!bubble) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          header.append(bubble);
        }
        let visible = bubble.querySelector('[aria-hidden="true"]');
        if (cart.item_count < 100) {
          if (!visible) {
            visible = document.createElement('span');
            visible.setAttribute('aria-hidden', 'true');
            bubble.prepend(visible);
          }
          visible.textContent = cart.item_count;
        } else visible?.remove();
        let accessible = bubble.querySelector('.visually-hidden');
        if (!accessible) {
          accessible = document.createElement('span');
          accessible.className = 'visually-hidden';
          bubble.append(accessible);
        }
        accessible.textContent = `${cart.item_count}個のアイテム`;
      }
    }

    // The visible BESIGN header is separate from Dawn's hidden header.
    const visibleCart = document.querySelector('.bs-nav__cart');
    if (!visibleCart) return;
    let badge = visibleCart.querySelector('span');
    if (!cart.item_count) badge?.remove();
    else {
      if (!badge) {
        badge = document.createElement('span');
        visibleCart.append(badge);
      }
      badge.textContent = cart.item_count;
    }
    visibleCart.setAttribute('aria-label', cart.item_count ? `カート、${cart.item_count}点` : 'カート');
  }

  function render() {
    if (!cart?.item_count) {
      root.hidden = true;
      close();
      syncHeaderCount();
      return;
    }
    root.hidden = false;
    count.textContent = cart.item_count;
    pill.setAttribute('aria-label', `カートを見る、${cart.item_count}点`);
    positionPill();
    syncHeaderCount();
    total.textContent = money(cart.total_price);
    const cartDiscount = cart.items.reduce((sum, item) => sum + item.final_line_price, 0) - cart.total_price;
    discount.hidden = cartDiscount <= 0;
    discountValue.textContent = cartDiscount > 0 ? `−${money(cartDiscount)}` : '';
    items.replaceChildren();
    cart.items.slice(0, 4).forEach((item) => {
      const row = document.createElement('div');
      row.className = 'bs-mini-cart__item';
      const image = document.createElement('img');
      image.className = 'bs-mini-cart__image';
      image.src = item.featured_image?.url || item.image || '';
      image.alt = '';
      image.loading = 'lazy';
      const details = document.createElement('div');
      const name = document.createElement('div');
      name.className = 'bs-mini-cart__name';
      name.textContent = item.product_title || item.title;
      details.append(name);
      if (item.variant_title && item.variant_title !== 'Default Title') {
        const variant = document.createElement('div');
        variant.className = 'bs-mini-cart__variant';
        variant.textContent = item.variant_title;
        details.append(variant);
      }
      const footer = document.createElement('div');
      footer.className = 'bs-mini-cart__item-footer';
      const quantity = document.createElement('div');
      quantity.className = 'bs-mini-cart__quantity';
      const minus = document.createElement('button');
      minus.type = 'button';
      minus.dataset.action = 'minus';
      minus.dataset.key = item.key;
      minus.textContent = '−';
      minus.setAttribute('aria-label', `${item.product_title || item.title}の数量を減らす`);
      minus.disabled = item.quantity <= 1;
      const input = document.createElement('input');
      input.type = 'number';
      input.min = '1';
      input.step = '1';
      input.inputMode = 'numeric';
      input.value = item.quantity;
      input.dataset.action = 'quantity';
      input.dataset.key = item.key;
      input.setAttribute('aria-label', `${item.product_title || item.title}の数量`);
      const plus = document.createElement('button');
      plus.type = 'button';
      plus.dataset.action = 'plus';
      plus.dataset.key = item.key;
      plus.textContent = '+';
      plus.setAttribute('aria-label', `${item.product_title || item.title}の数量を増やす`);
      quantity.append(minus, input, plus);
      const price = document.createElement('div');
      price.className = 'bs-mini-cart__price';
      price.textContent = money(item.final_line_price);
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'bs-mini-cart__remove';
      remove.dataset.action = 'remove';
      remove.dataset.key = item.key;
      remove.setAttribute('aria-label', `${item.product_title || item.title}を削除する`);
      remove.innerHTML = '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3m3 0-1 13H7L6 7m4 4v5m4-5v5"/></svg>';
      footer.append(quantity, price, remove);
      row.append(image, details, footer);
      items.append(row);
    });
    const remaining = cart.items.length - 4;
    more.hidden = remaining <= 0;
    more.textContent = remaining > 0 ? `ほか ${remaining} 商品` : '';
  }

  async function refresh() {
    if (updating) return;
    const requestId = ++refreshRequest;
    const response = await fetch(`${cartUrl}.js`, { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('Cart fetch failed');
    const nextCart = await response.json();
    if (requestId !== refreshRequest) return false;
    cart = nextCart;
    render();
    return true;
  }

  function updateSection(html, selector) {
    if (!html) return;
    const current = document.querySelector(selector);
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    if (current && fresh) current.replaceWith(fresh);
  }

  async function changeQuantity(key, quantity, label) {
    if (updating || !Number.isInteger(quantity) || quantity < 0) return;
    const oldItem = cart?.items.find((item) => item.key === key);
    if (!oldItem || oldItem.quantity === quantity) return;
    const oldIndex = cart.items.indexOf(oldItem);
    updating = true;
    refreshRequest += 1;
    error.hidden = true;
    root.classList.add('bs-mini-cart--updating');
    items.querySelectorAll('button, input').forEach((control) => { control.disabled = true; });
    try {
      const response = await fetch(`${cartUrl}/change.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: key,
          quantity,
          sections: ['cart-icon-bubble', 'main-cart-footer'],
          sections_url: cartUrl,
        }),
      });
      const nextCart = await response.json();
      if (!response.ok || nextCart.errors) throw new Error(nextCart.description || nextCart.message || '数量を変更できませんでした。');
      cart = nextCart;
      render();
      updateSection(nextCart.sections?.['cart-icon-bubble'], '#cart-icon-bubble');
      const footer = document.querySelector('#main-cart-footer .js-contents');
      const freshFooter = nextCart.sections?.['main-cart-footer'] && new DOMParser().parseFromString(nextCart.sections['main-cart-footer'], 'text/html').querySelector('.js-contents');
      if (footer && freshFooter) footer.replaceChildren(...freshFooter.childNodes);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        try {
          await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bs-mini-cart', cartData: nextCart });
        } catch (reason) {
          console.warn('Cart section refresh failed', reason);
        }
      }
      syncHeaderCount();
      announceCartChanged();
      status.textContent = quantity === 0 ? `${label}をカートから削除しました。` : `${label}の数量を${quantity}点に変更しました。`;
      if (quantity === 0 && cart.item_count) pill.focus({ preventScroll: true });
      else items.children[oldIndex]?.querySelector('[data-action="quantity"]')?.focus({ preventScroll: true });
    } catch (reason) {
      error.textContent = reason.message || 'カートを更新できませんでした。もう一度お試しください。';
      error.hidden = false;
      status.textContent = error.textContent;
    } finally {
      updating = false;
      root.classList.remove('bs-mini-cart--updating');
      items.querySelectorAll('button, input').forEach((control) => { control.disabled = false; });
      items.querySelectorAll('[data-action="minus"]').forEach((control) => {
        const item = cart?.items.find((line) => line.key === control.dataset.key);
        control.disabled = !item || item.quantity <= 1;
      });
    }
  }

  function fly(button, image) {
    if (!image?.src || matchMedia('(prefers-reduced-motion: reduce)').matches) return Promise.resolve();
    const context = button?.closest('.product, .card-wrapper, .quick-add-modal');
    const source = context?.querySelector('.product__media-item.is-active .product__media img, .product__media-item.swiper-slide-active .product__media img, .card__media img') || button;
    const rect = source?.getBoundingClientRect();
    const target = pill.getBoundingClientRect();
    if (!rect || !target.width || rect.bottom < 0 || rect.top > innerHeight) return Promise.resolve();
    const startX = rect.left + rect.width / 2;
    const startY = rect.top + rect.height / 2;
    const endX = target.left + 22;
    const endY = target.top + target.height / 2;
    const dx = endX - startX;
    const dy = endY - startY;
    const lift = Math.min(90, Math.max(40, Math.abs(dy) * .25));
    const endScale = Math.min(1, 42 / Math.max(rect.width, rect.height));
    const clone = document.createElement('img');
    clone.src = source instanceof HTMLImageElement ? (source.currentSrc || source.src) : image.src;
    clone.alt = '';
    clone.className = 'bs-mini-cart__flight';
    clone.style.left = `${rect.left}px`;
    clone.style.top = `${rect.top}px`;
    clone.style.width = `${rect.width}px`;
    clone.style.height = `${rect.height}px`;
    if (source instanceof HTMLImageElement) clone.style.objectFit = getComputedStyle(source).objectFit;
    document.body.append(clone);
    const animation = clone.animate([
      { transform: 'translate(0, 0) scale(1)', opacity: 1, offset: 0, easing: 'ease-out' },
      { transform: 'translate(0, -14px) scale(1.2)', opacity: 1, offset: .17, easing: 'ease-in-out' },
      { transform: 'translate(0, 4px) scale(.8)', opacity: 1, offset: .32, easing: 'ease-out' },
      { transform: `translate(${dx * .12}px, ${-lift}px) scale(.72)`, opacity: 1, offset: .48, easing: 'ease-in-out' },
      { transform: `translate(${dx * .55}px, ${dy * .32 - lift * 1.1}px) scale(.4)`, opacity: 1, offset: .68, easing: 'ease-in' },
      { transform: `translate(${dx * .91}px, ${dy * .78 - lift * .32}px) scale(${endScale * 2})`, opacity: 1, offset: .82, easing: 'ease-out' },
      { transform: `translate(${dx * 1.025}px, ${dy * 1.025}px) scale(${endScale * .9})`, opacity: .88, offset: .9, easing: 'ease-out' },
      { transform: `translate(${dx * .98}px, ${dy * .97 - 7}px) scale(${endScale * 1.18})`, opacity: .72, offset: .96, easing: 'ease-in-out' },
      { transform: `translate(${dx}px, ${dy}px) scale(${endScale})`, opacity: 0, offset: 1 },
    ], { duration: 900, easing: 'linear' });
    return animation.finished.catch(() => {}).finally(() => clone.remove());
  }

  window.BesignMiniCart = {
    onCartAdded(button, image) {
      // The add request has already succeeded. Start the flight immediately;
      // refreshing the cart summary should not add another visible wait.
      root.hidden = false;
      positionPill();
      fly(button, image).then(() => {
        pill.classList.remove('bs-mini-cart__bump');
        void pill.offsetWidth;
        pill.classList.add('bs-mini-cart__bump');
      });
      refresh().then((fresh) => {
        if (fresh) {
          announceCartChanged();
          status.textContent = `カートに追加しました。現在 ${cart.item_count} 点です。`;
        }
      }).catch(() => { window.location.href = cartUrl; });
      return true;
    },
  };

  pill.addEventListener('click', () => panel.hidden ? open() : close());
  items.addEventListener('click', (event) => {
    const control = event.target.closest('button[data-action]');
    if (!control || updating) return;
    const item = cart?.items.find((line) => line.key === control.dataset.key);
    if (!item) return;
    const action = control.dataset.action;
    const quantity = action === 'remove' ? 0 : item.quantity + (action === 'plus' ? 1 : -1);
    if (quantity >= 0) changeQuantity(item.key, quantity, item.product_title || item.title);
  });
  items.addEventListener('change', (event) => {
    const input = event.target.closest('input[data-action="quantity"]');
    if (!input || updating) return;
    const item = cart?.items.find((line) => line.key === input.dataset.key);
    if (!item) return;
    const quantity = Number(input.value);
    if (!Number.isInteger(quantity) || quantity < 1) {
      input.value = item.quantity;
      error.textContent = '数量は1以上の整数で入力してください。削除はゴミ箱を押してください。';
      error.hidden = false;
      return;
    }
    changeQuantity(item.key, quantity, item.product_title || item.title);
  });
  root.querySelector('.bs-mini-cart__close').addEventListener('click', () => { close(); pill.focus(); });
  document.addEventListener('click', (event) => {
    if (!panel.hidden && !root.contains(event.target)) close();
    const headerCart = event.target.closest('#cart-icon-bubble');
    if (headerCart && cart?.item_count && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) {
      event.preventDefault();
      panel.hidden ? open() : close();
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !panel.hidden) { close(); pill.focus(); }
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source !== 'product-form' && event.source !== 'bs-mini-cart') {
        refresh().then((fresh) => { if (fresh) announceCartChanged(); }).catch(() => {});
      }
    });
  }
  window.addEventListener('storage', (event) => {
    if (event.key === cartChangeKey) refresh().catch(() => {});
  });
  window.addEventListener('focus', () => refresh().catch(() => {}));
  window.addEventListener('pageshow', () => refresh().catch(() => {}));
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) refresh().catch(() => {});
  });
  window.addEventListener('resize', positionPill);
  window.addEventListener('scroll', positionPill, { passive: true });
  refresh().catch(() => {});
})();
